/**
 * @generated SignedSource<<96f4cd64fd21e0fdc19908bbce8f265f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoterPanelActionsFragment$data = {
  readonly statement: {
    readonly discord: string;
    readonly twitter: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelDelegateButtonFragment">;
  readonly " $fragmentType": "VoterPanelActionsFragment";
};
export type VoterPanelActionsFragment$key = {
  readonly " $data"?: VoterPanelActionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelActionsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoterPanelActionsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DelegateStatement",
      "kind": "LinkedField",
      "name": "statement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "twitter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "discord",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoterPanelDelegateButtonFragment"
    }
  ],
  "type": "WrappedDelegate",
  "abstractKey": null
};

(node as any).hash = "3a0876aaa8373d2581bf9059e8034bb9";

export default node;
